<template>
  <b-modal centered size="lg" ref="courseInvitations"
    id="courseInvitations" hide-footer title="Приглашение на курс"
    @show="onShow"
  >
    <div>
      <div style="margin: 16px">
        <b-form-select
          v-model="selectedOrg"
          :options="optionsOrg"
          v-b-tooltip.hover title="Организация"
          id="orgSelect"
          disabled
        >
        </b-form-select>
        <b-form-select
          v-model="selectedClass"
          :options="optionsClass"
          v-b-tooltip.hover
          title="Класс"
          id="classSelect"
          @change="getParticipantsFromClass"
        ></b-form-select>
      </div>
      <ag-grid-vue
          style="height: 300px !important;"
          class="ag-theme-material col-md-12 ag-grid-course-invitations"
          :columnDefs="columnDefs"
          :gridOptions="gridOptions"
          :rowData="participants"
          :suppressRowClickSelection="true"
          rowSelection="multiple"
          @selectionChanged="onSelectionChange"
          @grid-ready="onGridReady"
          :rowClassRules="rowClassRules"
      >
      </ag-grid-vue>
      <div style="margin-left: 16px; margin-top: 16px" v-if="hasRole(roles_.teacher)">
        <b-button
          variant="primary"
          :disabled="selectedOrg !== currUser.organizationId || selectedNum === 0"
          class="buttonFormEventMembers"
          @click="sendCourseInvitations"
        >
          Отправить приглашения
        </b-button>
        <b-button
          variant="outline-primary"
          :disabled="(selectedOrg !== currUser.organizationId) || !isChanged"
          @click="close"
          class="buttonFormEventMembers ml-1"
        >
          Отменить
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>

import { AgGridVue } from 'ag-grid-vue'
import { mapGetters, mapActions } from 'vuex'

import EducationAPI from '@/api/education'
import AG_GRID_LOCALE_RU from '@/config/locale.ru'
import { roles } from '@/config/roles'

export default {
  name: 'VModalCourseMembers',
  components: {
    'ag-grid-vue': AgGridVue
  },
  props: {
    title: {
      type: String,
      default() {
        return ''
      }
    }
  },
  data() {
    return {
      roles_: roles,
      isChanged: false,
      selectedOrg: null,
      selectedNum: 0,
      selectedClass: ['10', '11'],
      optionsClass: [
        { value: ['10', '11'], text: 'Все' },
        { value: ['10'], text: '10' },
        { value: ['11'], text: '11' }
      ],
      rowData: null,
      gridApi: null,
      columnApi: null,
      gridOptions: {
        defaultColDef: {
          autoHeight: true
        },
        headerHeight: 40,
        localeText: AG_GRID_LOCALE_RU
      },
      rowClassRules: {
        // eslint-disable-next-line quote-props
        'participate': (params) => params.data.userCourses.length > 0
      },
      filters: [{
        param: 'organizationId',
        needle: ['']
      }],
      columnDefs: [
        {
          headerName: 'Фамилия',
          field: 'surname',
          width: 170
        },
        {
          headerName: 'Имя',
          field: 'name',
          width: 170
        },
        {
          headerName: 'Отчество',
          field: 'midname',
          width: 170
        },
        {
          headerName: 'Класс',
          field: 'class',
          width: 100,
          valueFormatter: this.classFormatter
        },
        {
          headerName: 'Участие',
          field: 'part',
          sort: true,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          width: 140,
          valueFormatter: this.participationFormatter,
          valueGetter: this.participationVGetter,
          cellStyle: { color: '#017ac3', 'font-weight': '600' }
        }
      ],
      selectedStudents: []
    }
  },
  computed: {
    ...mapGetters({
      hasRole: 'currentUser/hasRole',
      currUser: 'currentUser/getCurrentUser',
      users: 'users/getUsers',
      orgs: 'dicts/getOrganizations',
      participants: 'educationStudentsManagement/getParticipants'
    }),
    optionsOrg() {
      if (this.orgs && this.orgs.length) {
        if (this.hasRole(this.roles_.teacher)) {
          return [{
            value: this.currUser.organizationId,
            text: this.orgs.find((p) => p.id === this.currUser.organizationId).title
          }]
        }
      }

      return []
    }
  },
  methods: {
    participationFormatter(params) {
      return params.data.userCourses.length > 0 ? 'Поступил' : ''
    },
    classFormatter(params) {
      return params.data.studentProfile.class
    },
    participationVGetter(params) {
      return params.data.userCourses.length > 0
    },
    onShow() {
      this.selectedOrg = this.orgs.find((p) => p.id === this.currUser.organizationId).id
      this.fetchParticipants({
        courseId: this.$route.params.courseBookId,
        classes: ['10', '11']
      })
    },
    onGridReady(params) {
      this.gridApi = params.api
      this.columnApi = params.columnApi
      this.gridApi.sizeColumnsToFit()
      this.setUpGridHandlers(params.api)
    },
    getParticipantsFromClass() {
      this.fetchParticipants({
        courseId: this.$route.params.courseBookId,
        classes: this.selectedClass
      }).then(() => {
        this.updateCheckboxes()
      })
    },
    updateCheckboxes() {
      this.gridApi.forEachNode((node) => (node.data.userCourses.length > 0 ? node.setSelected(true) : null))
    },
    onSelectionChange() {
      this.isChanged = true
      this.selectedNum = this.gridApi.getSelectedRows().length
      this.gridApi.forEachNode((node) => {
        if (node.data.userCourses.length > 0) {
          node.setSelected(true)
        }
      })
    },
    sendCourseInvitations() {
      const selectedRows = this.gridApi.getSelectedRows()
      EducationAPI.sendCourseInvitations(this.$route.params.courseBookId,
        selectedRows.filter((r) => r.userCourses.length === 0).map((r) => r.id))
        .then((response) => {
          if (response.status === 204) {
            this.pushToasts({
              title: 'Уведомление',
              message: 'Ученики успешно приглашены',
              time: 10
            }).then(() => {
              this.$emit('courseInvitationsWereSent')
            })
          }
        })
    },
    close() {
      this.$bvModal.hide('courseInvitations')
    },
    setUpGridHandlers(api) {
      setTimeout(() => {
        api.forEachNode((node) => (node.data.userCourses.length > 0
          ? node.setSelected(true) : null))
      }, 500)
    },
    ...mapActions({
      fetchParticipants: 'educationStudentsManagement/fetchCourseStudentsProgress',
      pushToasts: 'toasts/pushToasts'
    })
  }
}
</script>

<style lang="scss">
  .ag-grid-course-invitations .ag-row .ag-cell {
    white-space: normal !important;
    font-size: 13px !important;
    padding-left: 15px !important;
    text-align: left !important;
    justify-content: left;
  }
  .ag-grid-course-invitations .ag-body-viewport{
    overflow-y: scroll;
    border-bottom: 1px solid #017ac3 !important;
  }
  .ag-grid-course-invitations .ag-selection-checkbox {
    margin: auto
  }
  .ag-grid-course-invitations .ag-header-viewport {
    border-top: 1px solid #017ac3 !important;
  }
  #orgSelect {
    display: inline-block;
    width: 69%;
    margin-right: 2%;
  }
  #classSelect {
    display: inline-block;
    width: 29%;
  }
  .buttonFormEventMembers {
    width: 49%;
  }

  .ag-theme-material .participate {
    background-color: lightgray !important;

    .ag-cell .ag-cell-wrapper .ag-selection-checkbox {
      pointer-events: none;
      margin: 10px !important;
    }

    .ag-cell-value:not(:empty) {
      margin-left: 0 !important;
    }
  }
</style>
